module.exports = __webpack_public_path__ + "img/teacherNo1.b6eaed2e.png";